// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__DLu0b","scheduleTable":"styles_scheduleTable__Nt1eI","dayCell":"styles_dayCell__mKFsj","timeCell":"styles_timeCell__8i59N","days":"styles_days__T8XBW"};